export default "__VITE_ASSET__DI2B6uLA__ 320w, __VITE_ASSET__DvCJwf2h__ 640w";